const mutations = {
  recieveOrgUnits (state, orgUnits) {
    if (orgUnits) {
      state.orgUnits = orgUnits
      state.originalTree = orgUnits
    } else {
      state.selectedOrgUnit = null
      state.orgUnits = null
      state.originalTree = null
    }
  },
  selectOrgUnit (state, orgUnit) {
    state.selectedOrgUnit = orgUnit
  }
}

export default mutations
